import React from 'react';
import '../styles/export-branding.css';
import logoSrc from '../assets/img/large_logo.svg';

const ExportFooter: React.FC = ({ ...props }: { className?: string, [key: string]: any }) => {
  return (
    <footer {...props}>
      <div className="footer-panel">
        <div className="footer-left">
          <div className="item">
            <div className="logo-container">
              <img src={logoSrc} alt="deiterate logo" className="logo" />
            </div>
            <span>Powered by de.iterate</span>
          </div>
        </div>
        <div className="footer-right">
          <div className="footer-wedge"></div>
          <div className="item">
            {/* mail */}
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" strokeWidth="1.8">
              <rect x="3" y="5" width="18" height="14" rx="2"/>
              <path d="M3 7.5 12 13l9-5.5"/>
            </svg>
            <span>hello@deiterate.com</span>
          </div>
          <div className="item">
            {/* globe */}
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" strokeWidth="1.8">
              <circle cx="12" cy="12" r="9"/>
              <path d="M3 12h18M12 3a15.3 15.3 0 0 1 0 18M12 3a15.3 15.3 0 0 0 0 18"/>
            </svg>
            <span>deiterate.com</span>
          </div>
        </div>
      </div>
      <div className="footer-bar"></div>
    </footer>
  );
};

export default ExportFooter;